module.exports = __webpack_public_path__ + "static/media/screenshot-mreddit.81db8b20.png";